import * as React from 'react';
import classNames from 'classnames';
import TimeHeader from './TimeHeader';
import TimeBody from './TimeBody';
import { createKeyDownHandler } from '../../utils/uiUtil';
const countBoolean = (boolList) => boolList.filter(bool => bool !== false).length;
function TimePanel(props) {
    const { generateConfig, format = 'HH:mm:ss', prefixCls, active, operationRef, showHour, showMinute, showSecond, use12Hours = false, onSelect, value } = props;
    const panelPrefixCls = `${prefixCls}-time-panel`;
    const bodyOperationRef = React.useRef();
    // ======================= Keyboard =======================
    const [activeColumnIndex, setActiveColumnIndex] = React.useState(-1);
    const columnsCount = countBoolean([showHour, showMinute, showSecond, use12Hours]);
    operationRef.current = {
        onKeyDown: event => createKeyDownHandler(event, {
            onLeftRight: diff => {
                setActiveColumnIndex((activeColumnIndex + diff + columnsCount) % columnsCount);
            },
            onUpDown: diff => {
                if (activeColumnIndex === -1) {
                    setActiveColumnIndex(0);
                }
                else if (bodyOperationRef.current) {
                    bodyOperationRef.current.onUpDown(diff);
                }
            },
            onEnter: () => {
                onSelect(value || generateConfig.getNow(), 'key');
                setActiveColumnIndex(-1);
            }
        }),
        onBlur: () => {
            setActiveColumnIndex(-1);
        }
    };
    return (<div className={classNames(panelPrefixCls, {
            [`${panelPrefixCls}-active`]: active
        })}>
            <TimeHeader {...props} format={format} prefixCls={prefixCls}/>
            <TimeBody {...props} prefixCls={prefixCls} activeColumnIndex={activeColumnIndex} operationRef={bodyOperationRef}/>
        </div>);
}
export default TimePanel;
